import Vue from 'vue'
import Vuex from 'vuex'
import users from './modules/users'
import notificaciones from './modules/notificaciones'
import ui from './modules/ui'


Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    user: null
  },
  getters: {
  },
  mutations: {
  },
  actions: {
  },
  modules: { 
    users,
    notificaciones,
    ui
   }
})
